const LoggerPlugin = {
  install (Vue, options) {
    let logLevelList = ['DEBUG', 'INFO', 'WARNING', 'ERROR']
    let defaultLogLevel = logLevelList[0]
    let logger = {
      logLevel: defaultLogLevel,
      setLogLevel: function (logLevel) {
        let targetLogLevel = defaultLogLevel
        if (logLevelList.indexOf(logLevel) >= 0) {
          targetLogLevel = logLevel
        }
        try {
          Vue.logger.logLevel = targetLogLevel
          console.log('LogLevel: ' + Vue.logger.logLevel)
        } catch (err) {}
      },
      debug: function (str) {
        let logLevel = defaultLogLevel
        try {
          let targetLogLevel = Vue.logger.logLevel
          if (targetLogLevel) logLevel = targetLogLevel
        } catch (err) {}
        if (logLevelList.indexOf(logLevel) <= logLevelList.indexOf('DEBUG')) {
          console.log('DEBUG: ' + ((str instanceof Object) ? JSON.stringify(str, null, 2) : str))
        }
      },
      info: function (str) {
        let logLevel = defaultLogLevel
        try {
          let targetLogLevel = Vue.logger.logLevel
          if (targetLogLevel) logLevel = targetLogLevel
        } catch (err) {}
        if (logLevelList.indexOf(logLevel) <= logLevelList.indexOf('INFO')) {
          console.log('INFO: ' + ((str instanceof Object) ? JSON.stringify(str, null, 2) : str))
        }
      },
      warn: function (str) {
        let logLevel = defaultLogLevel
        try {
          let targetLogLevel = Vue.logger.logLevel
          if (targetLogLevel) logLevel = targetLogLevel
        } catch (err) {}
        if (logLevelList.indexOf(logLevel) <= logLevelList.indexOf('WARNING')) {
          console.warn('WARNING: ' + ((str instanceof Object) ? JSON.stringify(str, null, 2) : str))
          // console.warn(str)
        }
      },
      error: function (str) {
        let logLevel = defaultLogLevel
        try {
          let targetLogLevel = Vue.logger.logLevel
          if (targetLogLevel) logLevel = targetLogLevel
        } catch (err) {}
        if (logLevelList.indexOf(logLevel) <= logLevelList.indexOf('ERROR')) {
          console.warn('ERROR: ' + ((str instanceof Object) ? JSON.stringify(str, null, 2) : str))
          // console.error(str)
        }
      }
    }
    window.setLogLevel = logger.setLogLevel
    Vue.prototype.$logger = logger
    Vue.logger = logger
  }
}

export default LoggerPlugin



// WEBPACK FOOTER //
// ./src/plugins/logger.js